import React from 'react';
import { Spin } from 'antd';
import cn from 'classnames';
import styles from './SpinWrapper.module.scss';

const SpinWrapper = ({ className, ...props }) => {
  return <Spin {...props} wrapperClassName={cn(styles.root, className)} />;
};

export default SpinWrapper;
